/* eslint-disable @typescript-eslint/no-explicit-any */
import qs from "qs";
import { api } from "../api/httpClient";
import { buildUrl } from "@/utils/bindUrl";
import { IListParams } from "@/interfaces/serviceInterface";
import {
  IOccurrenceType,
  IResponseListOccurrenceType,
  IResponseShowOccurrenceType,
} from "@/interfaces/occurrenceTypes";

const BASE = "/occurrence-types";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listOccurrenceTypes({
  filter,
  includes,
  page,
  limit,
  sort,
}: IListParams) {
  const { data } = await api.get<IResponseListOccurrenceType>(BASE, {
    params: { filter, includes, page, limit, sort },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showOccurrenceType({ id }: { id: string | number }) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowOccurrenceType>(url);
  return data;
}

export async function createOccurrenceType({
  occurrenceType,
}: {
  occurrenceType: IOccurrenceType;
}) {
  const { data } = await api.post<IResponseShowOccurrenceType>(BASE, { occurrenceType });
  return data;
}

export async function updateOccurrenceType({
  id,
  occurrenceType,
}: {
  id: string | number;
  occurrenceType: Partial<IOccurrenceType>;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowOccurrenceType>(url, { occurrenceType });
  return data;
}

export async function deleteOccurrenceType({ id }: { id: string | number }) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  // validateStatus => true devolve a falha em vez de lançar, para o chamador tratar a mensagem.
  const resp = await api.delete(url, { validateStatus: () => true });
  return { status: resp.status, data: resp.data };
}
